import "./sapb1content.css"

const webcontent = () =>{
    return (
        
                      <div className="container mt-4">
            <div className="row align-items-center">
                <div className="col-lg-6 col-md-6 col-12">
                    <div className="saptitle erptitle">What is SAP Business One used for?</div>
                <p className="erppara"> 
                With the SAP Business One solution, you can drive profitable business growth with streamlined processes, greater insight, and strategic decision-making based on real-time information.
                </p>
                <ul className="websub erpul">
	                <li className="webpoints">On-premise or cloud deployment</li>
                    <li className="webpoints">Integrated business intelligence</li>
                </ul>
                
                    </div>
                <div className="col-lg-6 col-md-6 col-12">
                    <img src="https://www.belcan.com/wp-content/uploads/2022/08/Evolution-of-Engineering-Drawings-600x300.jpg" alt="erp" className="img-erp img-shadow" />
                </div>
            </div>
        </div>
 
        
    )
}

export default webcontent